import ClientSchemaReduced from "../Client/SchemaReduced";
import DriverSchemaReduced from "../Driver/SchemaReduced";

const todayDate = `${(new Date()).getFullYear()}-${(new Date()).getMonth()+1}-${(new Date()).getDate()}`;
const dateEnd = new Date(`${todayDate} 23:55:00`);
const dateStart = new Date(`${todayDate} 00:00:00`);

const schema = {
  active: true,
  client: JSON.parse(JSON.stringify(ClientSchemaReduced)),
  dateEnd,
  dateStart,
  driver: JSON.parse(JSON.stringify(DriverSchemaReduced)),
  id: ""
};

export default schema;
